var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 44,
    viewBox: "0 0 53 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144_38353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6098 36.6958V11.1138H28.1279V7.45928L18.9915 3.80469L9.85518 7.45928V11.1139H4.37334V36.6958H0.71875V40.3504H37.2644V36.6958H33.6098ZM11.6824 33.0412H8.02784V29.3866H11.6824V33.0412ZM11.6824 25.7321H8.02784V22.0775H11.6824V25.7321ZM11.6824 18.423H8.02784V14.7684H11.6824V18.423ZM20.8189 33.0412H17.1643V29.3866H20.8189V33.0412ZM20.8189 25.7321H17.1643V22.0775H20.8189V25.7321ZM20.8189 18.423H17.1643V14.7684H20.8189V18.423ZM29.9552 33.0412H26.3006V29.3866H29.9552V33.0412ZM29.9552 25.7321H26.3006V22.0775H29.9552V25.7321ZM29.9552 18.423H26.3006V14.7684H29.9552V18.423Z",
    fill: "#BDC3C6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8828 0.150391V44.0053",
    stroke: "#D6DCDF",
    strokeWidth: 1.82729
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144_38353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5456,
    height: 36.5456,
    fill: "white",
    transform: "translate(0.71875 3.80469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.1f6c7435e3978e6f410363c2630d3bbe.svg";
export { ForwardRef as ReactComponent };